import React, { useEffect } from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import { Container, Row, Col, Card, Modal } from 'react-bootstrap';
import contactbanner from '../Assets/food/50.png';
import '../Assets/WebsiteCss/contact.css';
import aboutimgofowner from '../Assets/food/bhojmal_savli_Image.webp'
import certificate1 from '../Assets/Image/certificate1.jpg';
import certificate2 from '../Assets/Image/certificate2.jpg';
import certificate3 from '../Assets/Image/certificate3.jpg';
import ownerImg from '../Assets/Image/achivement4.jpg'
import teamImg from '../Assets/Image/achivement1.jpg'
import award1Img from '../Assets/Image/achivement2.jpg'
import award2Img from '../Assets/Image/achivement3.jpg'
import eventImg from '../Assets/Image/achivement5.jpg'
import { useState } from 'react';
import { Helmet } from "react-helmet";


export default function Team() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // const images = [
  //   { src: ownerImg, title: 'Leadership That Inspires' },
  //   { src: teamImg, title: 'Preferred by Our Clients' },
  //   { src: award1Img, title: 'Trusted by Industry Clients' },
  //   { src: award2Img, title: 'Trusted by Valued Clients' },
  //   { src: eventImg, title: 'Successful Collaboration' },
  // ];
  // const certificates = [
  //   {
  //     src: certificate1,
  //     title: 'Big Impact Award 2025',
  //     description:
  //       'Awarded to Mr. Narayan Salvi for outstanding contribution to the manpower and namkeen industry. Presented by Ritu Shivpuri.',
  //   },
  //   {
  //     src: certificate2,
  //     title: 'Big Impact Award to Mr. Narayan Salvi',
  //     description:
  //       'This certificate acknowledges the dedication and leadership of Mr. Narayan Salvi in supporting skilled labor and manufacturing excellence across India.',
  //   },
  // ];

  // const [show, setShow] = useState(false);
  // const [modalImg, setModalImg] = useState('');

  // const handleShow = (img) => {
  //   setModalImg(img);
  //   setShow(true);
  // };

  return (
    <>
      <div className="mainnav min-vh-100">
        <Helmet>
          <title> Achievements |Karigar India Namkeen Labour Contractor – Trusted Taste Since 15+ Years</title>
          <meta
            name="description"
            content="Namkeen Labour Contractor, led by Bhojml Salvi, delivers premium Bikaneri Bhujia, Ratlami Sev & Mix Namkeen with 15+ years of expertise across India."
          />
        </Helmet>

        {/* Banner */}
        <div className="service-container">
          <img src={contactbanner} alt="" className="servicenamkken img-fluid" />
          <div className="service-text" style={{ color: "rgb(35, 50, 106)" }}>Celebrating Milestones That Define Our Taste Legacy</div>
        </div>

        <Container>
          <div className="mb-2 mt-3" >
            <h2 className="middletext mb-3" data-aos="zoom-in">Meet the Founder</h2>
            <Row className='introductionOwner'>
              <Col lg={5} className="d-flex justify-content-center">
                <img
                  src={aboutimgofowner}
                  alt=""
                  style={{ height: "300px", width: '70%', objectFit: 'fill', borderRadius: "8px" }}
                />
              </Col>
              <Col lg={7} >
                <p className='p-3' style={{ textAlign: "justify" }}>
                  I <b>Bhojml Salvi</b>, the Owner of Namkeen Labour Contractor, has more than 15 years of experience in the domain of Bikaneri Growth Bhujiya, Rajasthan mix special, Rtlami sev, etc. Located at Rajasthan (India), the company has been flourishing under the management and skills of the owner.

                  Our purpose is to deliver superior-quality namkeen products and services to customers across a wide range of regions. With a proven track record of successfully completing numerous namkeen manufacturing contracts across India, we specialize in providing end-to-end solutions, from namkeen production to final packaging.

                  Today, our products have earned strong recognition and trust in several states, including Madhya Pradesh, Uttar Pradesh, Punjab, Maharashtra, and many other parts of India.

                  We are known for offering crispy, flavorful, and high-quality namkeen that meets customer expectations and market demand. Among our specialties, Mix Namkeen and Ratlami Sev stand out as our most popular and widely loved products, appreciated for their authentic taste and consistent quality.
                </p>
              </Col>
            </Row>
          </div>

          {/* <Container className="my-5">
          
            <h2 className="middletext text-center mb-3" data-aos="fade-up">
              Our Certificates
            </h2>

      
            <p className="text-muted text-center mb-5 px-2" data-aos="fade-up" data-aos-delay="100">
              We are proud to be honored at the <strong>Big Impact Awards 2025</strong> in Udaipur for our
              outstanding contribution to the manpower and namkeen production industry. This recognition
              was presented to <strong>Mr. Narayan Salvi</strong>, Founder of NS Namkeen Labour Contractor –
              Apna Karigar, by actress <strong>Ritu Shivpuri</strong>. These certificates reflect our
              commitment to excellence and trust.
            </p>
            <Row className="justify-content-center">
              <Col md={6} sm={8} xs={12} className="text-center">
                <img
                  src={certificate3}
                  alt="Certificate"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "450px",
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                  onClick={() => handleShow(certificate3)}
                />
              </Col>
            </Row>

            {certificates.map((cert, index) => (
              <Row
                key={index}
                className={`align-items-center mb-5 ${index % 2 !== 0 ? 'flex-md-row-reverse' : ''}`}
                data-aos="fade-up"
              >
       
                <Col md={6} className="mb-4 mb-md-0" onClick={() => handleShow(cert.src)}>
                  <div className="certificate-wrapper position-relative">
                    <span className="ribbon">Awarded</span>
                    <Card className="certificate-card shadow-sm border-0">
                      <Card.Img
                        src={cert.src}
                        alt={cert.title}
                        className="certificate-img rounded"
                        style={{ height: '100%', maxHeight: '450px', objectFit: 'cover', cursor: 'pointer' }}
                      />
                    </Card>
                  </div>
                </Col>

                <Col md={6} className="d-flex flex-column justify-content-start">
                  <h4 className="fw-bold mb-2">{cert.title}</h4>
                  <p className="text-muted">{cert.description}</p>
                  <p>
                    <strong>Awarded to:</strong> Mr. Narayan Salvi <br />
                    <strong>Presented by:</strong> Actress Ritu Shivpuri <br />
                    <strong>Organization:</strong> NS Namkeen Labour Contractor – Apna Karigar
                  </p>
                </Col>
              </Row>
            ))}

   
            <Modal show={show} onHide={() => setShow(false)} size="lg" centered>
              <Modal.Body className="p-0">
                <img src={modalImg} alt="Certificate Full View" className="w-100" />
              </Modal.Body>
            </Modal>
          </Container>
          <div className="mb-4 mt-4">
            <h2 className="middletext mb-3 text-center" data-aos="zoom-in">A Glimpse of Our Showcase</h2>
            <p className="text-muted text-center mb-4">Watch how our vision turned into reality with hard work and dedication.</p>
            <div className="d-flex justify-content-center">
              <video className="founder-video" controls>
                <source src={require('../Assets/Image/Event video.mp4')} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div> */}

        </Container>

      </div>
    </>
  )
}
